import { render, staticRenderFns } from "./tooth-color-select.vue?vue&type=template&id=39653844&"
import script from "./tooth-color-select.vue?vue&type=script&lang=js&"
export * from "./tooth-color-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports